import { services ,hooks} from "../../../studentportal-sdk"
import { 
    useEffect 
} from 'react';


export const CourseHook = ( props ) => {

    // course service instance
    const _courseService  = services.Course(props);

    const {
        store:{courseAction},
        action:{
            getCourseById,
            getAllCourse,
            removeCourseAction
        },
        history
      } = _courseService

      useEffect(() => {
      
        getAllCourse();
    }, []);

    useEffect(() => {
        if (["/editcourse", "/coursedetails"].includes(history.location.pathname)) {
            return;
        }

        removeCourseAction()

    }, []);
    
    
    useEffect(() => {
        const courseId = localStorage.getItem('courseId');
        if (courseId) getCourseById(courseId);
    
        if (courseAction && courseAction.action === "view"  && ['/coursedetails', '/courses'].includes(history.location.pathname)) {
            history.replace('/coursedetails');
        } else if (courseAction && courseAction.action === "edit" && courseAction.id) {
            history.replace('/editcourse');
        }
    }, [courseAction]);

     
    return {
        courseService: {
            ..._courseService
        },
        ...props
    };
}

export const course = (props) => CourseHook(hooks.UtilityAndConfig(props))